import { createAction, props } from '@ngrx/store';

export const CARRIER_LANES = {
	LANES_LIST: {
		GET: createAction('[CARRIER_LANES] Get carrier lanes list', props<any>()),
		SUCCESS: createAction('[CARRIER_LANES] Get carriers lanes list success', props<any>()),
		FAILURE: createAction(
			'[CARRIER_LANES] Get carrier lanes list failure',
			props<{ payload: { message: string } }>()
		),
	},

	SET: {
		PAGE: createAction('[CARRIER_LANES] Set loads sourcing page', props<any>()),
		PAGE_SIZE: createAction('[CARRIER_LANES] Set loads sourcing page size', props<any>()),
		FILTER_LIST: createAction('[CARRIER_LANES] set filters list', props<{ filtersList: any[] }>()),
		SORT_LIST: createAction('[CARRIER_LANES] set sorts list', props<{ sortList: any[] }>()),
	},

	DELETE_LANES: {
		CONFIRM: createAction('[CARRIER_LANES] confirm delete carrier lanes list', props<any>()),
		CLOSE: createAction(
			'[CARRIER_LANES] close delete carrier lanes confirmation dialog',
			props<any>()
		),
		DELETE: createAction('[CARRIER_LANES] delete carrier lanes list', props<any>()),
		SUCCESS: createAction('[CARRIER_LANES] delete carriers lanes list success', props<any>()),
		FAILURE: createAction(
			'[CARRIER_LANES] delete carrier lanes list failure',
			props<{ payload: { message: string } }>()
		),
	},

	EXCLUDE_LANES: {
		CONFIRM: createAction('[CARRIER_LANES] confirm exclude carrier lanes list', props<any>()),
		CLOSE: createAction(
			'[CARRIER_LANES] close exclude carrier lanes confirmation dialog',
			props<any>()
		),
		DELETE: createAction('[CARRIER_LANES] exclude carrier lanes list', props<any>()),
		SUCCESS: createAction('[CARRIER_LANES] exclude carriers lanes list success', props<any>()),
		FAILURE: createAction(
			'[CARRIER_LANES] exclude carrier lanes list failure',
			props<{ payload: { message: string } }>()
		),
	},

	ASSIGN_TO_ACCOUNT: {
		CONFIRM: createAction('[CARRIER_LANES] confirm assign carrier lanes to account', props<any>()),
		CLOSE: createAction(
			'[CARRIER_LANES] close assign carrier lanes to account confirmation dialog',
			props<any>()
		),
		ASSIGN: createAction('[CARRIER_LANES] assign carrier lanes to account list', props<any>()),
		SUCCESS: createAction('[CARRIER_LANES] assign carriers lanes to account success', props<any>()),
		FAILURE: createAction(
			'[CARRIER_LANES] assign carrier lanes to account failed',
			props<{ payload: { message: string } }>()
		),
	},
	DELETE_BROKER_ACCOUNT_MAP: {
		DELETE: createAction('[CARRIER_LANES] delete carrier lanes broker account map', props<any>()),
		SUCCESS: createAction(
			'[CARRIER_LANES] delete carriers lanes broker account map success',
			props<any>()
		),
		FAILURE: createAction(
			'[CARRIER_LANES] delete carrier lanes broker account map failed',
			props<{ payload: { message: string } }>()
		),
	},

	CONFIRM_ACCOUNT: createAction('[CARRIER_LANES] confirm carrier account', props<any>()),

	RESET_STATE: createAction('[CARRIER_LANES] Reset page state', props<any>()),
};
